import { SegmentedControl } from "@mantine/core";

export const BaseSegmentedControl = SegmentedControl